import { pmtQueryParams } from './queryParameters.constants';
const { ShipmentFsId, Section, Milestone, ShowEdd, UtmSource, UtmCampaign, UtmMedium } = pmtQueryParams;

export const shipmentSummaryRequiredGtmParams = [ShipmentFsId, Section, Milestone, ShowEdd];
export const utmQueryParams = [UtmSource, UtmCampaign, UtmMedium];
export const shipmentSummaryGtmParams = [...shipmentSummaryRequiredGtmParams, ...utmQueryParams];
